<template>
  <section>
    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-6 col-md-6 col-sm-6 col-6 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>

          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-6 text-right">
          <div class="box-buttons">
            <base-button
              type="outline-neutral"
              class="min-button "
              @click="saveDocument('stay')"
            >
              <i class="flaticon-file icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save & New</strong>
            </base-button>

            <base-button
              type="primary"
              class="min-button ml-2"
              @click="saveDocument('redirect')"
            >
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <tabs
        tabNavClasses="tabs-home justify-content-around tab-profiles"
        :value="tabActive"
        @changeTabActive="changeTabActive"
        type="primary"
      >
        <tab-pane
          class="tabs-home-content"
          id="Overview"
          title="Overview"
          ref="Overview"
        >
          <div class="row">
            <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12">
              <div class="row">
                <div class="col-xl-12">
                  <div
                    class="card"
                    v-bind:class="{
                      'invalid-card': $v.document.images.$error
                    }"
                  >
                    <div class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12">
                      <label
                        for="insuranceCard"
                        class="title-label-np"
                        v-bind:class="{
                          'is-invalid': $v.document.images.$error
                        }"
                      >
                        Cover Image
                        <el-popover
                          placement="top"
                          trigger="hover"
                          width="300"
                          class="curp"
                        >
                          <ul class="ul-pop">
                            <li>Allowed Dimensions: 780 x 420 px</li>
                            <li>Maximum Size: 2MB</li>
                            <li>Allowed Formats: GIF,JPG,JPEG,PNG</li>
                          </ul>
                          <div class="badge badge-primary" slot="reference">
                            <span>?</span>
                          </div>
                        </el-popover>
                      </label>
                      <div>
                        <div class="imageload2">
                          <div class="image">
                            <div
                              v-if="imagePreview"
                              v-bind:style="{
                                backgroundImage: 'url(' + imagePreview + ')'
                              }"
                              class="imgLogoIcon"
                            ></div>
                            <div
                              v-else
                              v-bind:style="{
                                backgroundImage: 'url(' + imageDefault + ')'
                              }"
                              class="imgLogoIcon"
                            ></div>
                          </div>
                          <div class="contentfile2">
                            <base-dropdown menuOnRight>
                              <base-button
                                slot="title-container"
                                type="primary"
                                class="dropdown-toggle btn-icon-only buttonfiles2"
                              >
                                <i class="flaticon-camera m-0"></i>
                              </base-button>
                              <span class="dropdown-item">
                                <base-input
                                  class="filebutton2"
                                  type="file"
                                  name="imagepreview"
                                  id="imagepreview"
                                  accesskey="insurance"
                                  enctype="multipart/form-data"
                                  accept="image/jpeg, image/jpg, image/png"
                                  @change="uploadFile"
                                ></base-input
                                >Upload Image
                              </span>
                              <span
                                class="dropdown-item"
                                v-if="imagePreview"
                                @click="clearfile('insurance')"
                                >Remove</span
                              >
                            </base-dropdown>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="$v.document.images.$error"
                    class="invalid-feedback mb-2"
                  >
                    Select a cover image
                  </div>
                </div>
                <div class="col-xl-12">
                  <div class="card">
                    <div class="row">
                      <div class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12">
                        <WSelect
                          filterable
                          remote
                          placeholder="Select a Status"
                          v-model.trim="$v.document.status.$model"
                          id="status_search"
                          name="status_search"
                          label="Status"
                          clearable
                          markrequired
                          :error="
                            $v.document.status.$error ? `Select a Status` : ''
                          "
                        >
                          <el-option
                            v-for="(item, index) in status"
                            class="select-danger"
                            :value="item.value"
                            :label="`${item.label}`"
                            :key="index"
                          ></el-option>
                        </WSelect>
                      </div>

                      <div class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12">
                        <base-input
                          v-model="createdAt"
                          label="Date"
                          placeholder="Date"
                          id="date"
                          name="date"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-9 col-lg-12 col-md-12 col-sm-12 col-12">
              <div class="card">
                <h2 class="subtitle mb-3">Parameters</h2>
                <div class="row">
                  <div
                    class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 option-transfers"
                    v-bind:class="{
                      'is-invalid': $v.document.type.$error
                    }"
                  >
                    <label class="title-label">
                      <span class="markrequired">*</span>Type
                      <el-popover
                        placement="bottom"
                        trigger="hover"
                        width="350"
                        class="curp"
                      >
                        <span>
                          <ul>
                            <li>
                              <strong>- Guide: </strong> is an essential
                              document that provides detailed instructions to
                              help users understand and operate a system. It
                              offers guidance on the system's interface,
                              features, and capabilities, facilitating a more
                              effective and comprehensive user Document.
                            </li>
                            <br />
                            <li>
                              <strong>- Release: </strong>It is the document
                              that details the release of a specific version,
                              which may contain changes or improvements compared
                              to previous versions.
                            </li>
                            <br />
                            <li>
                              <strong>- Support: </strong>A system support guide
                              is a document or resource that provides detailed
                              information on how to address issues, resolve
                              difficulties, and seek technical assistance
                              related to a specific system. This guide is
                              designed to help users troubleshoot problems
                              independently or to provide essential information
                              that facilitates effective communication with the
                              technical support team.
                            </li>
                          </ul>
                        </span>
                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover>
                    </label>

                    <b-form-radio-group
                      id="btn-radios-1"
                      v-model="document.type"
                      :options="typeDocument"
                      @change="selectDocumentType"
                      name="document_types"
                      value-field="value"
                      text-field="label"
                      button-variant="group-neutral pc-1"
                      tabindex="3"
                      buttons
                      class="buttons-type"
                      v-bind:class="{
                        'is-invalid': $v.document.type.$error
                      }"
                    ></b-form-radio-group>
                    <small
                      class="invalid-feedback"
                      v-if="$v.document.type.$error"
                      >Select a document Type</small
                    >
                  </div>

                  <div
                    class="col-xl-4 col-lg-4 col-md-6 col-sm-6 mt-xl-0 mt-lg-0 mt-md-0 mt-sm-0 mt-3"
                  >
                    <WSelect
                      filterable
                      remote
                      placeholder="Select an App"
                      v-model.trim="document.app"
                      id="app_filter"
                      name="app_filter"
                      label="App"
                      clearable
                      :error="$v.document.app.$error ? `Select an App` : ''"
                      @change="selectDocumentApp"
                      markrequired
                    >
                      <el-option
                        v-for="(item, index) in apps"
                        class="select-danger"
                        :value="item.value"
                        :label="`${item.name}`"
                        :key="index"
                      ></el-option>
                    </WSelect>
                  </div>

                  <div
                    class="col-xl-4 col-lg-4 col-md-6 col-sm-6 "
                    v-if="document.type !== 'RELEASE'"
                  >
                    <WSelect
                      filterable
                      remote
                      reserve-keyword
                      placeholder="Select a Module"
                      v-model.trim="document.module"
                      id="modules_search"
                      name="modules_search"
                      label="Module"
                      clearable
                      :error="
                        $v.document.module.$error ? `Select a Module` : ''
                      "
                    >
                      <el-option
                        v-for="(item, index) in modules"
                        class="select-danger"
                        :value="item.value"
                        :label="`${item.name}`"
                        :key="index"
                      ></el-option>
                    </WSelect>
                  </div>
                </div>
              </div>

              <div class="card" v-if="document.type === 'RELEASE'">
                <h2 class="subtitle mb-3">Release</h2>
                <div class="row">
                  <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                    <WSelect
                      filterable
                      remote
                      placeholder="Select a release type"
                      v-model.trim="document.release.type"
                      id="releasetype"
                      name="releasetype"
                      label="Type"
                      clearable
                      markrequired
                      @change="
                        changeVersion(document.release.type, release.version)
                      "
                      :disabled="document.app === ''"
                      :error="
                        $v.document.release.type.$error ? `Select a Type` : ''
                      "
                    >
                      <el-option
                        v-for="(item, index) in releaseTypes"
                        class="select-danger"
                        :value="item.value"
                        :label="`${item.label}`"
                        :key="index"
                      ></el-option>
                    </WSelect>
                  </div>

                  <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                    <base-input
                      v-model="$v.document.release.version.$model"
                      label="Version"
                      placeholder="Version"
                      id="version"
                      name="version"
                      disabled
                    />
                  </div>
                </div>
              </div>

              <div class="card">
                <h2 class="subtitle mb-3">Details</h2>
                <div class="row">
                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-3"
                    v-bind:class="{
                      'is-invalid': $v.document.title.$error
                    }"
                  >
                    <label class="title-label">
                      <span class="markrequired">*</span>Name | Title
                      <el-popover
                        placement="bottom"
                        trigger="hover"
                        width="350"
                        class="curp"
                      >
                        <span>
                          It's the name that identifies the document. This name
                          is taken as the Meta Title of the document. Must be
                          unique.
                          <br />
                        </span>
                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover>
                    </label>
                    <el-input
                      v-model="$v.document.title.$model"
                      placeholder="Document title"
                      id="document_title"
                      name="document_title"
                      @input="createDocumentSlug"
                      tabindex="1"
                      maxlength="160"
                      type="textarea"
                      :autosize="{ minRows: 1, maxRows: 2 }"
                      show-word-limit
                      autofocus
                    >
                    </el-input>

                    <div
                      v-if="$v.document.title.$error"
                      class="invalid-feedback mb-0 mt--1"
                    >
                      {{ validationMessageForDocumentName($v.document.title) }}
                    </div>
                  </div>

                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-4"
                    v-bind:class="{
                      'is-invalid': $v.document.short_description.$error
                    }"
                  >
                    <label
                      slot="label"
                      for="document_short_description"
                      class="title-label"
                      ><span class="markrequired">*</span>Short Description
                      <el-popover
                        placement="bottom"
                        trigger="hover"
                        width="350"
                        class="curp"
                      >
                        <span>
                          Add a short description of the Document
                        </span>
                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover></label
                    >

                    <el-input
                      v-model="$v.document.short_description.$model"
                      placeholder="Document short_description"
                      id="document_short_description"
                      name="document_short_description"
                      tabindex="15"
                      maxlength="160"
                      type="textarea"
                      :autosize="{ minRows: 1, maxRows: 2 }"
                      show-word-limit
                    >
                    </el-input>

                    <div
                      v-if="$v.document.short_description.$error"
                      class="invalid-feedback mt--1"
                    >
                      {{
                        $v.document.short_description.$error
                          ? `Enter from ${$v.document.short_description.$params.minLength.min} to ${$v.document.short_description.$params.maxLenght.max} characters.`
                          : ""
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-pane>

        <tab-pane
          class="tabs-home-content"
          id="Content"
          title="Content"
          ref="Content"
        >
          <div class="row">
            <div class="col-xl-12">
              <div class="card pb-4">
                <h2
                  class="subtitle mb-2"
                  v-bind:class="{
                    'is-invalid': $v.document.content.$error
                  }"
                >
                  <span class="markrequired">*</span>Content
                  <el-popover
                    placement="bottom"
                    trigger="hover"
                    width="350"
                    class="curp"
                  >
                    <span>
                      Add a content as it will be a part of the document.
                    </span>
                    <div class="badge badge-primary" slot="reference">
                      ?
                    </div>
                  </el-popover>
                </h2>
                <div class="row">
                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                    v-bind:class="{
                      'is-invalid': $v.document.content.$error
                    }"
                  >
                    <vue-editor
                      v-model="document.content"
                      id="editordocument"
                      ref="myEditor"
                      @ready="onEditorReady"
                    />
                    <div
                      v-if="$v.document.content.$error"
                      class="invalid-feedback mt--1"
                    >
                      Enter 200 to 20000 characters
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-pane>
      </tabs>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { DocumentsAPI } from "../../../../../core/api";
import flatPicker from "vue-flatpickr-component";
import moment from "moment-timezone";
import lodash from "lodash";
import "flatpickr/dist/flatpickr.css";
import { Switch, Card, DatePicker } from "element-ui";
import Swal from "sweetalert2";
import { VueEditor } from "vue2-editor";
import { APPS, MODULES } from "../../../../../core/constants";
import {
  required,
  minLength,
  maxLength,
  requiredIf
} from "vuelidate/lib/validators";
import WSelect from "@/components/Select";
import { goBack, setSigOut } from "../../../../../helpers/commons.helpers";
import { FileService } from "../../../../../core/services";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "NewDocument",
  data() {
    return {
      document: {
        type: "",
        app: "",
        module: "",
        title: "",
        slug: "",
        status: "",
        short_description: "",
        content: "",
        date: moment().format(),
        images: [],
        release: {
          type: "",
          version: ""
        }
      },
      typeDocument: [
        { label: "Guide", value: "GUIDE" },
        { label: "Release", value: "RELEASE" },
        { label: "Support", value: "SUPPORT" }
      ],
      status: [
        {
          label: "Draft",
          value: "DRAFT",
          icon: "status-draft"
        },
        {
          label: "In Revision",
          value: "REVISION",
          icon: "text-warning"
        },
        {
          label: "Approved",
          value: "APPROVED",
          icon: "text-new"
        },
        {
          label: "Published",
          value: "PUBLISHED",
          icon: "text-success"
        }
      ],
      apps: APPS,
      modules: MODULES,
      imageDefault: require("rhomtrip_assets/src/img/no-preview.png"),
      imagePreview: null,
      releaseTypes: [
        {
          label: "Major",
          value: "MAJOR"
        },
        {
          label: "Medium",
          value: "MEDIUM"
        },
        {
          label: "Minimum",
          value: "MINIMUM"
        }
      ],
      tabActive: "Overview",
      documentCopy: {},
      createdAt: moment().format("DD MMM. YYYY - hh:mm A"),
      onSave: false,
      release: {
        type: "MINIMUM",
        version: "0.0.0",
        app: ""
      }
    };
  },
  async created() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },
      {
        text: "Tools",
        to: "/tools"
      },
      {
        text: "Documentation",
        to: "/tools/documentation"
      },
      {
        text: "New Document",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.documentCopy = lodash.cloneDeep(this.document);
    if (this.$route.query.duplicate) {
      await this.duplicateDocument(this.$route.query.duplicate);
    }
  },
  methods: {
    async saveDocument(action, route = null) {
      if (!this.$v.document.$invalid) {
        let document = lodash.cloneDeep(this.document);
        document.date = moment().format();
        await this.createDocument(document, route, action);
      } else {
        this.$v.document.$touch();
        let tab = this.getTabByInvalidDocumentData(this.$v.document);
        this.changeTabActive(tab);
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async createDocument(document, route, action) {
      try {
        this.setLoad(true);
        let { data } = await DocumentsAPI.createDocument(
          document,
          this.sesion.token
        );
        this.setLoad(false);
        this.onSave = true;
        if (data.status) {
          let { document } = data.data;
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Document has been Saved",
            icon: "flaticon-check-mark"
          });
          this.performOtherActions(route, document._id, action);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.onSave = true;
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      }
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    createDocumentSlug(title) {
      this.document.slug = this.createSlug(title.trim());
    },
    createSlug(title = "") {
      return title
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^\w\s-]/g, "")
        .replace(/\s+/g, "-");
    },
    resetData() {
      this.document.app = "";
      this.document.module = "";
      this.document.title = "";
      this.document.slug = "";
      this.document.status = "";
      this.document.short_description = "";
      this.document.content = "";
      this.document.images = "";
      this.document.type = "";

      this.document.release.type = "";
      this.document.release.version = "";

      this.documentCopy = lodash.cloneDeep(this.document);
      this.imagePreview = null;
      this.tabActive = "Overview";
      this.createdAt = moment().format("DD MMM. YYY- hh:mm A");
      this.onSave = false;
      this.release = lodash.cloneDeep({
        type: "MINIMUM",
        version: "0.0.0",
        app: ""
      });
      this.$v.$reset();
    },
    performOtherActions(route, documentId, action = "redirect") {
      if (action === "redirect") {
        this.$router.push(
          route ? route : `/tools/documentation/${documentId}?mode=view`
        );
      } else {
        this.resetData();
      }
    },
    async checkDocumentSlugIsDuplicate(slug, app) {
      try {
        let { data } = await DocumentsAPI.checkDocumentSlugIsDuplicate(
          slug,
          app,
          this.sesion.token
        );
        return data.status ? !data.data.isDuplicate : false;
      } catch (error) {
        return false;
      }
    },
    validationMessageForDocumentName(name) {
      if (name.$error) {
        if (!name.required) {
          return "Enter the document title";
        } else if (!name.minLength || !name.maxLenght) {
          return `Enter from ${name.$params.minLength.min} to ${name.$params.maxLenght.max} characters`;
        } else if (!name.customValidator) {
          return "Document title is already used";
        }
      } else {
        return "";
      }
    },
    async uploadFile(event) {
      let [file] = event.target.files;
      if (file.size > 720 * 480) {
        event.preventDefault();
        this.$notify({
          type: "danger",
          title: "Error!",
          message:
            "The image cannot be larger than 2MB nor exceed 780x480px dimensions",
          icon: "flaticon-remove"
        });
        this.clearfile();
      } else {
        let fileData = FileService.generateResourceData(
          "/documents/covers",
          file.name
        );
        let queryString = FileService.buildQueryString(fileData);
        let urlFile = await FileService.uploadResource(file, queryString);
        if (urlFile) {
          this.imagePreview = URL.createObjectURL(file);
          this.document.images = [urlFile];
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "The image cannot be larger than 2MB nor exceed 500x500px dimensions",
            icon: "flaticon-remove"
          });
        }
      }
    },
    clearfile() {
      this.imagePreview = null;
      this.document.images = [];
    },
    changeTabActive(tabActive) {
      this.tabActive = tabActive;
    },
    changeVersion(releaseType, lastVersion = "0.0.0") {
      const version = lastVersion.split(".").map(Number);
      if (releaseType === "MAJOR") {
        this.document.release.version = [(version[0] += 1), 0, 0].join(".");
      } else if (releaseType === "MEDIUM") {
        this.document.release.version = [version[0], (version[1] += 1), 0].join(
          "."
        );
      } else {
        this.document.release.version = [
          version[0],
          version[1],
          (version[2] += 1)
        ].join(".");
      }
    },
    async duplicateDocument(documentId) {
      try {
        this.setLoad(true);
        let { data } = await DocumentsAPI.getDocumentById(
          documentId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          let document = data.data;
          this.document.type = document.type;
          this.document.app = document.app;
          if (document.type !== "RELEASE") {
            this.document.module = document.module;
          }
          this.document.title = document.title;
          this.document.slug = document.slug;
          this.document.status = "";
          this.document.short_description = document.short_description;
          this.document.content = document.content;
          this.document.images = document.images;
          [this.imagePreview] = document.images;
          this.document.release = {
            type: "",
            version: ""
          };
          if (this.document.type === "RELEASE" && this.document.app) {
            let release = await this.getLastReleaseByApp(this.document.app);
            if (release) {
              this.release = release;
            }
          }
          this.documentCopy = lodash.cloneDeep(this.document);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    async detectChanges(to, from, next) {
      let isEqual = lodash.isEqual(this.document, this.documentCopy);
      if (!isEqual && !this.onSave) {
        let { value, dismiss } = await Swal.fire({
          title: "Important",
          html:
            "The document has been modified. <br> Do you want to save changes?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        });
        if (value) {
          this.saveDocument("redirect", to.path);
        } else if (dismiss === Swal.DismissReason.cancel) {
          next();
        }
      } else {
        next();
      }
    },
    isInDocumentModule(modules = []) {
      if (!(modules.indexOf("document") > -1)) {
        this.setDocumentSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    getTabByInvalidDocumentData(document) {
      let parameters =
        document.type.$invalid ||
        document.app.$invalid ||
        document.module.$invalid ||
        document.release.$invalid;
      let details =
        document.short_description.$invalid || document.title.$invalid;
      let status = document.status.$invalid;
      let images = document.images.$invalid;
      if (parameters || details || status || images) {
        return "Overview";
      } else {
        return "Content";
      }
    },
    async getLastReleaseByApp(app) {
      try {
        let { data } = await DocumentsAPI.getLastReleaseByApp(
          app,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return null;
        }
      } catch (error) {
        return null;
      }
    },
    async selectDocumentType(type) {
      this.document.release.type = "";
      this.document.release.version = "";
      if (type === "RELEASE" && this.document.app) {
        let release = await this.getLastReleaseByApp(this.document.app);
        if (release) {
          this.release = release;
        }
      }
    },
    async selectDocumentApp(app) {
      this.release.app = app;
      if (this.document.type === "RELEASE" && app) {
        this.document.release.type = "";
        this.document.release.version = "";
        let release = await this.getLastReleaseByApp(app);
        if (release) {
          this.release = release;
        }
      }
    },
    /**
     * Converts a base64 data URL to a File object.
     * @param {string} dataUrl - The base64 data URL.
     * @param {string} filename - The desired filename for the File object.
     * @returns {File} - The resulting File object.
     */
    base64ToFile(dataUrl, filename) {
      const [meta, content] = dataUrl.split(",");
      const mime = meta.match(/:(.*?);/)[1];
      const bstr = atob(content);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) u8arr[n] = bstr.charCodeAt(n);
      return new File([u8arr], filename, { type: mime });
    },
    /**
     * Called when the editor is ready.
     * @param {Object} quill - The Quill editor instance.
     */
    onEditorReady(quill) {
      quill.on("text-change", (delta, oldDelta, source) => {
        if (source !== "user") return;
        const editor = quill.root;
        const images = editor.querySelectorAll("img");
        images.forEach(async img => {
          const src = img.getAttribute("src");
          if (src && src.startsWith("data:image")) {
            const file = this.base64ToFile(src, `image-${Date.now()}.png`);
            let fileData = FileService.generateResourceData(
              "/documents/covers",
              file.name
            );
            let queryString = FileService.buildQueryString(fileData);
            let urlFile = await FileService.uploadResource(file, queryString);
            if (urlFile) {
              img.setAttribute("src", urlFile);
            }
          }
        });
      });
    },
    ...mapActions(["getBranchsOptions"]),
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setDocumentSearchCriteria"
    ])
  },
  components: {
    [Switch.name]: Switch,
    [Card.name]: Card,
    [DatePicker.name]: DatePicker,
    flatPicker,
    WSelect,
    VueEditor
  },
  computed: {
    ...mapGetters(["sesion", "sigout"])
  },
  beforeRouteLeave(to, from, next) {
    this.isInDocumentModule(to.meta.modules);
    this.detectChanges(to, from, next);
  },
  validations: {
    document: {
      title: {
        required,
        minLength: minLength(40),
        maxLenght: maxLength(160),
        customValidator: async function(value) {
          if (value.length >= 40 && value.length <= 160) {
            let slug = this.createSlug(value);
            if (slug && this.document.app) {
              return await this.checkDocumentSlugIsDuplicate(
                slug,
                this.document.app
              );
            } else {
              return true;
            }
          } else {
            return false;
          }
        }
      },
      type: {
        required
      },
      app: {
        required
      },
      module: {
        required: requiredIf(function(value) {
          return this.document.type !== "RELEASE";
        })
      },
      release: {
        type: {
          required: requiredIf(function(value) {
            return this.document.type === "RELEASE";
          })
        },
        version: {
          required: requiredIf(function(value) {
            return this.document.type === "RELEASE";
          })
        }
      },
      status: {
        required
      },
      images: {
        required,
        minLength: minLength(1),
        maxLenght: maxLength(8)
      },
      content: {
        required,
        minLength: minLength(200),
        maxLenght: maxLength(20000)
      },
      short_description: {
        required,
        minLength: minLength(50),
        maxLenght: maxLength(160)
      },
      slug: {
        required
      }
    }
  }
};
</script>
